/**
 * Openers for the portfolio assistant. Written as things a visitor would
 * actually wonder, and scoped to what the assistant can answer well.
 */
const askSuggestions = [
  'What is USSD, and why still build on it?',
  'How do you make an app work with no connection?',
  "What's the story behind BuniAI?",
  'What did you build at One Acre Fund?',
];

export default askSuggestions;
